import { directApiInstance } from './httpClient';

export interface GKUser {
  username: string;
  sub: string;
  preferred_username: string;
  phone_number: string;
  tenant_id: string;
  status: string;
  enabled: boolean;
  created: string;
  last_modified: string;
}

export interface CreateGKUserRequest {
  preferred_username: string;
  phone_number: string;
  password: string;
}

export interface ListGKUsersResponse {
  users: GKUser[];
  count: number;
}

// NOTE: the shared response interceptor unwraps `response.data`, so these
// helpers resolve to the payload type at runtime even though Axios types the
// call as `AxiosResponse<T>`. Cast through `unknown` (same idiom as useArticles).
export const listGKUsers = async (): Promise<ListGKUsersResponse> => {
  return directApiInstance<ListGKUsersResponse>({
    url: '/gk/users',
    method: 'GET',
  }) as unknown as ListGKUsersResponse;
};

export const createGKUser = async (data: CreateGKUserRequest): Promise<{ message: string; user: GKUser }> => {
  return directApiInstance<{ message: string; user: GKUser }>({
    url: '/gk/users',
    method: 'POST',
    data,
  }) as unknown as { message: string; user: GKUser };
};

export const deleteGKUser = async (username: string): Promise<{ message: string }> => {
  return directApiInstance<{ message: string }>({
    url: `/gk/users/${encodeURIComponent(username)}`,
    method: 'DELETE',
  }) as unknown as { message: string };
};

export const approveGkUser = async (username: string): Promise<GKUser> => {
  return directApiInstance<GKUser>({
    url: `/gk/users/${encodeURIComponent(username)}/approve`,
    method: 'POST',
  }) as unknown as GKUser;
};

export const rejectGkUser = async (username: string): Promise<{ deleted: boolean }> => {
  return directApiInstance<{ deleted: boolean }>({
    url: `/gk/users/${encodeURIComponent(username)}/reject`,
    method: 'POST',
  }) as unknown as { deleted: boolean };
};
